import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import RotablesLayer from '../components/RotablesLayer';

const RotablesPage = () => {
  return (
    <MasterLayout pageTitle='Rotables'>
      <RotablesLayer />
    </MasterLayout>
  );
};

export default RotablesPage;
